// extracted by mini-css-extract-plugin
export var acitonButtons = "_gd-0";
export var additionalIcon = "_gd-f";
export var block = "_gd-1";
export var blockContent = "_gd-7";
export var blockDescription = "_gd-8";
export var blockIcon = "_gd-9";
export var blockTitle = "_gd-6";
export var border = "_gd-a";
export var center = "_gd-l";
export var edge = "_gd-b";
export var edgeLabel = "_gd-c";
export var edgePath = "_gd-d";
export var error = "_gd-e";
export var flowchart = "_gd-g";
export var flowchartContent = "_gd-h";
export var highlighted = "_gd-3";
export var hover = "_gd-4";
export var icon = "_gd-i";
export var left = "_gd-m";
export var navButton = "_gd-j";
export var navButtons = "_gd-k";
export var right = "_gd-n";
export var selected = "_gd-2";
export var small = "_gd-5";